
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParticipantVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantVisit"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"protocolName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visitTemplate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisitTemplate"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"visitInstance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisitInstance"},"directives":[]}]}}]}}],"loc":{"start":0,"end":271}};
    doc.loc.source = {"body":"#import \"../visits/VisitTemplateFragment.graphql\"\n#import \"../visits/VisitInstanceFragment.graphql\"\n\nfragment ParticipantVisit on ParticipantVisit {\n    protocolName,\n    visitTemplate {\n        ...VisitTemplate\n    },\n    visitInstance {\n        ...VisitInstance\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../visits/VisitTemplateFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../visits/VisitInstanceFragment.graphql").definitions));


      module.exports = doc;
    
